import Vue from 'vue';
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    loadApprovalPins: [],
    loadApprovalPin: {},
    loadApprovalPinForm: false,
    loadApprovalLogs: [],
    verifyToShipObj: {
      pin: null,
      sonum: null
    },
    verifyToShipStatus: false,
    verifyToShipForm: false,
    operation: null,
    pending: false
  },
  mutations: {
    setLoadApprovalPins(state, loadApprovalPins) {
      state.loadApprovalPins = loadApprovalPins;
    },
    setLoadApprovalPin(state, loadApprovalPin) {
      state.loadApprovalPin = loadApprovalPin;
    },
    setLoadApprovalLogs(state, loadApprovalLogs) {
      state.loadApprovalLogs = loadApprovalLogs;
    },
    append(state, loadApprovalPin) {
      const found = state.loadApprovalPins.find(sl => sl.id == loadApprovalPin.id);
      if (!found) {
        state.loadApprovalPins.push(loadApprovalPin);
        state.loadApprovalPin = loadApprovalPin;
      }
    },
    replace(state, { o, n }) {
      const i = _.findIndex(state.loadApprovalPins, { id: o.id });
      if (i !== -1) {
        Vue.set(state.loadApprovalPins, i, n);
        if (state.loadApprovalPin.id === n.id) state.loadApprovalPin = n;
      }
    },
    remove(state, id) {
      const i = _.findIndex(state.loadApprovalPins, { id });
      Vue.delete(state.loadApprovalPins, i);
    },
    setLoadApprovalPinForm(state, loadApprovalPinForm) {
      state.loadApprovalPinForm = loadApprovalPinForm;
    },
    toggleLoadApprovalPinForm(state, operation) {
      if (operation === 'create') state.loadApprovalPin = { pin: null };
      state.operation = operation;
      state.loadApprovalPinForm = !state.loadApprovalPinForm;
    },
    setVerifyToShipObj(state, verifyToShipObj) {
      state.verifyToShipObj = verifyToShipObj;
    },
    setverifyToShipStatus(state, verifyToShipStatus) {
      state.verifyToShipStatus = verifyToShipStatus;
    },
    setVerifyToShipForm(state, verifyToShipForm) {
      state.verifyToShipForm = verifyToShipForm;
    },
    setPending(state, pending) {
      state.pending = pending;
    },
    clearState(state) {
      state.loadApprovalPins = [];
      state.loadApprovalPin = {};
      state.loadApprovalPinForm = false;
      state.pending = false;
    }
  },
  actions: {
    async fetchLoadApprovalPins({ state, commit }) {
      try {
        state.pending = true;
        const res = await axios.get('/load-approval-pins');
        if (res && res.data) {
          commit('setLoadApprovalPins', res.data.loadApprovalPins);
        }
      } finally {
        state.pending = false;
      }
    },
    async fetchLoadApprovalLogs({ state, commit }) {
      try {
        state.pending = true;
        const res = await axios.get('/load-approval-logs');
        if (res && res.data) {
          commit('setLoadApprovalLogs', res.data.loadApprovalLogs);
        }
      } finally {
        state.pending = false;
      }
    },
    async createLoadApprovalPin({ state, dispatch, commit }, pin) {
      try {
        pin.pin = parseInt(pin.pin);
        pin.sonum = parseInt(pin.sonum);
        pin.ttl = parseInt(pin.ttl);
        state.pending = true;
        const res = await axios.post(`/load-approval-pins`, pin);
        if (res && res.data) {
          commit('append', res.data.loadApprovalPin);
          commit('setLoadApprovalPin', res.data.loadApprovalPin);
          dispatch('fetchLoadApprovalPins');
        }
      } finally {
        state.pending = false;
      }
    },
    async updateLoadApprovalPin({ commit }, pin) {
      pin.id = parseInt(pin.id);
      pin.pin = parseInt(pin.pin);
      pin.sonum = parseInt(pin.sonum);
      pin.ttl = parseInt(pin.ttl);
      delete pin.user;
      const res = await axios.patch(`/load-approval-pins/${pin.id}`, pin);
      if (res && res.data) commit('replace', { o: pin, n: res.data.loadApprovalPin });
    },
    async deleteLoadApprovalPin({ commit }, { id }) {
      const res = await axios.delete(`/load-approval-pins/${id}`);
      if (res && res.data) commit('remove', id);
    },
    async verifyToShip({ state, rootState, commit }) {
      const { verifyToShipObj: v } = state;
      const res = await axios.post(`/verify-to-ship?pin=${v.pin}&so=${v.sonum}`);
      if (res && res.data) {
        commit('setverifyToShipStatus', true);
        const { loads } = rootState.dock.dock;
        const i = _.findIndex(loads, l => parseInt(l.salesOrder.sonum) === v.sonum);
        if (i !== -1) {
          loads[i].salesOrder.customer.creditHold = false;
          loads[i].salesOrder.customer.creditHoldCOD = false;
        }
      }
    }
  }
};
